module.exports = __webpack_public_path__ + "img/qq.e60b412e.png";